<ion-header class="modal-header">
  <div class="modal-title">
    <h3>Create tenant</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        shape="round"
        class="close-button"
        (click)="dismiss()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="create-tenant-modal">
  <div>
    <ion-grid style="margin: 12px 2px">
      <div style="margin: 0px 15px">
        <ion-list lines="none">
          <ion-item>
            <ion-label position="stacked">Subdomain</ion-label>
            <ion-input
              [(ngModel)]="subdomain"
              placeholder="piedpiper"
            ></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Name</ion-label>
            <ion-input [(ngModel)]="name" placeholder="Pied Piper"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="stacked"
              >Allowed email domains (comma separated)</ion-label
            >
            <ion-input
              [(ngModel)]="allowedEmailDomains"
              placeholder="unthread.io"
            ></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Enabled password auth?</ion-label>
            <ion-checkbox [(ngModel)]="passwordAuthEnabled"></ion-checkbox>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Enabled Google auth?</ion-label>
            <ion-checkbox [(ngModel)]="googleAuthEnabled"></ion-checkbox>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Start trial?</ion-label>
            <ion-checkbox [(ngModel)]="trialEnabled"></ion-checkbox>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Is internal use-case?</ion-label>
            <ion-checkbox [(ngModel)]="isInternalSupport"></ion-checkbox>
          </ion-item>
          <ion-item
            *ngIf="!hasUpdatedAuthorizedRedirectUris"
            [disabled]="!subdomain"
          >
            <ion-label position="stacked"
              >Add URL to authorized redirects</ion-label
            >
            <ion-button (click)="updateAuthorizedRedirects()"
              >Copy URL and go to GCP console</ion-button
            >
          </ion-item>
        </ion-list>
      </div>
    </ion-grid>
    <div class="padded-row">
      <ion-button
        class="btn-large submit-button"
        expand="block"
        (click)="submit()"
        [disabled]="isLoading"
      >
        <ion-spinner name="crescent" [hidden]="!isLoading"></ion-spinner>
        <span [hidden]="isLoading">Submit</span>
        <span [hidden]="!isLoading">Submitting...</span>
      </ion-button>
    </div>
  </div>
</ion-content>
